async function imagesLoaded(array = document.images) {
  const promises = Array.from(array)
    .filter((img) => !img.complete)
    .map((img) => new Promise((resolve) => (img.onload = img.onerror = resolve)));

  await Promise.all(promises);
}

export default imagesLoaded;
